import React, { useState } from "react";
import { Container, Button } from "@mui/material";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "../../../../../styles/index.scss";
import DiscountsEditorFields from "../../../../DiscountsEditorFields/DiscountsEditorFields";
import useCoinDetails from "../../../../../hooks/useCoinDetails";
import { ECurrencyCode } from "../../../../../Enums/Coin";

function Discounts({ product, setModalOpen, list, setDataTable }) {
  const [discountsList, setDiscountsList] = useState([]);
  const { currentCoinCode, convertToCurrency } = useCoinDetails();

  const handleSave = () => {
    const amountsDiscount = discountsList.map(item => item.Percent);
    const amounts = discountsList.map(item =>
      convertToCurrency({
        amount: item.Amount,
        fromCurrencyCode: currentCoinCode,
        toCurrencyCode: ECurrencyCode.DOLLAR,
      }),
    );
    setDataTable(
      list.map(item =>
        product.id === item.id
          ? {
              ...item,
              discount: amountsDiscount,
              discountAmount: amounts,
            }
          : item,
      ),
    );
    if (amountsDiscount.length === 0) {
      setDataTable(
        list.map(item =>
          product.id === item.id
            ? {
                ...item,
                discountAmount: [0],
                discount: [0],
              }
            : item,
        ),
      );
    }
    setModalOpen(false, "");
    toast.success("¡Descuentos registrados con éxito!", {
      toastId: "discount",
    });
  };

  return (
    <Container
      sx={{
        padding: { xs: "1rem", md: "3rem" },
        display: "flex",
        gap: "1rem",
        flexDirection: "column",
        width: {
          xs: "90%",
          sm: "488px",
        },
        height: "487px",
        backdropFilter: "blur(15px)",
      }}
    >
      <h3> Descuentos</h3>
      <DiscountsEditorFields
        defaultDiscounts={product?.discount || []}
        discountsList={discountsList}
        productTotal={product.total}
        onDiscountsListChange={newDiscountsList =>
          setDiscountsList(newDiscountsList)
        }
      />
      <div className="content-flex-end">
        <Button
          color="primary"
          sx={{ width: "30%" }}
          type="Button"
          variant="contained"
          onClick={handleSave}
        >
          Confirmar
        </Button>
      </div>
    </Container>
  );
}

Discounts.propTypes = {
  product: PropTypes.object.isRequired,
  list: PropTypes.array.isRequired,
  setModalOpen: PropTypes.func.isRequired,
  setDataTable: PropTypes.func.isRequired,
};

export default Discounts;
